var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"profile-menu-modal","hide-footer":"","hide-header":"","hide-backdrop":""},scopedSlots:_vm._u([{key:"modal-header",fn:function(){return undefined},proxy:true}])},[_vm._v(" "),_c('UserSection'),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('LogoutSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }